import { DialogType } from '@/enums/dialogType'
import api from '@/services/api'

export default {
    namespaced: true,
    state: {
        product: {},
        lstProduct: [],
        isUpdate: false,
        shouldReload: false,
        search: "",
        itemsPerPage: 25,
        hasNext: false,
        page: 1,
        totalItems: 0,
        headers: [
            { title: 'Produto', key: 'productId', align: 'center' },
            { title: 'Nome', key: 'productName', align: 'center' },
            { title: 'Descrição', key: 'productDesc', align: 'center' },
            { title: 'Tamanho', key: 'productSize', align: 'center' },
        ],
    },
    getters: {
        getProduct(state) {
            let product = { ...state.product }
            return product
        }
    },
    mutations: {
        setProduct(state, product) {
            state.product = product
        },
        setLstProduct(state, lstProduct) {
            state.lstProduct = lstProduct
        },
        appendLstProduct(state, items) {
            state.lstProduct = [...state.lstProduct, ...items]
        },
        clearLstProduct(state) {
            state.lstProduct = []
        },
        setPage(state, page) {
            state.page = page
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setTotalItems(state, total) {
            state.totalItems = total
        },
        setShouldReload(state, reload) {
            state.shouldReload = reload
        },
        initForm(state) {
            state.isUpdate = false
            state.product = {}
            state.search = ''
        },
        setUpdating(state) {
            state.isUpdate = true
        }
    },
    actions: {
        async save({ state, dispatch }) {
            if (state.isUpdate) {
                return await dispatch('update')
            }
            else
                return await dispatch('insert')
        },

        async insert({ getters, dispatch }) {
            await api.post(
                '/Product/Insert',
                getters.getProduct
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Produto salvo'
            }, { root: true })

            return true
        },

        async update({ getters, dispatch }) {
            await api.put(
                '/Product/Update',
                getters.getProduct
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Produto atualizado'
            }, { root: true })

            return true
        },

        async search({ state, commit }, { search, limit = 25, page = 1, reset}) {
            let searchParam = search || state.search
            const response = await api.get(
                `/Product/Search?search=${searchParam}&limit=${limit}&page=${page}`
            )

            if (reset) {
                commit("setLstProduct", response.data.items)
            } else {
                commit("appendLstProduct", response.data.items)
            }

            commit('setHasNext', response.data.hasNext)
            commit('setTotalItems', response.data.totalCount)
            commit('setPage', page)

            return true
        },

        async find({commit}, productId) {
            const response = await api.get(
                `/Product/Find/${productId}`,
            )
            commit('setProduct', response.data)
            commit('setUpdating')

            return true
        },

        async findAll({ commit }) {
            const response = await api.get(
                `/Product/FindAll/`,
            )
            commit('setLstProduct', response.data)
            
            return true
        },

        async delete({ getters, dispatch }) {
            await api.delete(
                `/Product/Delete/${getters.getProduct.productId}`,
            )
            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Registro deletado com sucesso!'
            }, { root: true })

            return true
        }
    }
}